import type { Infer } from 'superstruct';
import { boolean, object, optional } from 'superstruct';

import { makeRecord } from '@adflow/shared/util-js';
import { permissionSystem } from '@adflow/shared/util-permissions';

const PermissionValuesDto = object(
	makeRecord(permissionSystem.actionTypes, () => optional(boolean()))
);

export const EditPermissionsDto = object(
	makeRecord(permissionSystem.permissionTypes, () =>
		optional(PermissionValuesDto)
	)
);

export type EditPermissionsDto = Infer<typeof EditPermissionsDto>;
